<template>
    <div class="container-fluid">
        <admin-header :name="$t('Contracts')" @create="newContract" :add-new="addNewBtn"/>
        <router-view name="contract"/>
    </div>
</template>
<script>
export default {
    computed: {
        addNewBtn() {
            return this.$route.fullPath == '/auth/contracts' || this.$route.fullPath == '/auth/contracts/';
        }
    },
    methods: {
        newContract() {
            this.$router.push({name:'contracts.create.empty'});
        }
    },
    metaInfo() {
        return {
            title: this.$t('Contracts')
        };
    }
};
</script>
